import { createIcon } from '@chakra-ui/react';

export const SharedIconArrowDown = createIcon({
  displayName: 'SharedIconArrowDown',
  viewBox: '0 0 14 9',
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: [
    <path
      d="M.42 1.058c.523-.535 1.251-.577 1.89 0L7 5.554l4.69-4.496c.64-.577 1.369-.535 1.889 0 .523.534.49 1.436 0 1.938-.488.502-5.634 5.402-5.634 5.402a1.314 1.314 0 01-1.892 0S.91 3.498.42 2.996c-.49-.502-.523-1.404 0-1.938z"
      fill="currentColor"
    />
  ]
});
